import { useRecoilValue } from "recoil";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";
import OperationsGroupTable from "./view/OperationsGroupTable";

interface Props {}

export const EmailDomain: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_emaildomain_view;
    const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <OperationsGroupTable />} </>
  );
};

export default EmailDomain;
